// src/modules/serviceRecords/hooks/serviceFormHelpers.js
// Servis formu yardımcı fonksiyonları

import { db } from '../../../firebase';
import {
    collection, serverTimestamp, Timestamp, doc,
    updateDoc, increment, runTransaction
} from 'firebase/firestore';

/**
 * Yeni servis kaydı oluşturma (Transaction ile atomik)
 */
export const createServiceRecord = async (serviceRecordData, kullanilanParcalar) => {
    // Stok azaltma
    for (const item of kullanilanParcalar) {
        if (item.tip === 'urun' && item.referansId) {
            const stockRef = doc(db, "stocks", item.referansId);
            await updateDoc(stockRef, {
                stokAdedi: increment(-item.miktar)
            });
        }
    }

    // Transaction ile serviceNo oluştur ve kayıt ekle
    await runTransaction(db, async (transaction) => {
        const counterRef = doc(db, "settings", "counters");
        const counterDoc = await transaction.get(counterRef);

        let newServiceNo = 100;
        if (counterDoc.exists()) {
            const currentCount = counterDoc.data().serviceNo;
            if (typeof currentCount === 'number') {
                newServiceNo = currentCount + 1;
            }
        }

        const newRecordRef = doc(collection(db, "serviceRecords"));
        const newRecordData = {
            ...serviceRecordData,
            serviceNo: newServiceNo,
            durum: "Beklemede",
            olusturmaTarihi: serverTimestamp()
        };

        transaction.set(counterRef, { serviceNo: newServiceNo }, { merge: true });
        transaction.set(newRecordRef, newRecordData);

        // Eğer oluşturma aşamasında bir ödeme alınmışsa (odenenTutar > 0)
        if (serviceRecordData.odenenTutar && serviceRecordData.odenenTutar > 0) {
            const sharedId = doc(collection(db, "transactions")).id;

            // 1. Transaction kaydı oluştur (Cari İşlem)
            const transactionRef = doc(db, "transactions", sharedId);
            transaction.set(transactionRef, {
                customerId: serviceRecordData.musteriId,
                customerName: serviceRecordData.musteriAdSoyad,
                type: "tahsilat",
                amount: serviceRecordData.odenenTutar,
                paymentMethod: serviceRecordData.odemeTipi || "Nakit",
                description: `Servis Peşinatı: #${newServiceNo}`,
                timestamp: serverTimestamp(),
                refId: newRecordRef.id,
                refType: 'service'
            });

            // 2. Müşteri bakiyesini güncelle
            const customerRef = doc(db, "customers", serviceRecordData.musteriId);
            transaction.update(customerRef, {
                bakiye: increment(-serviceRecordData.odenenTutar)
            });

            // 3. Servis kaydına alt koleksiyon olarak (payments) ekle
            const paymentRef = doc(newRecordRef, "payments", sharedId);
            transaction.set(paymentRef, {
                tutar: serviceRecordData.odenenTutar,
                odemeYontemi: serviceRecordData.odemeTipi || "Nakit",
                aciklama: `Servis Peşinatı: #${newServiceNo}`,
                tarih: serverTimestamp(),
                musteriId: serviceRecordData.musteriId,
                musteriAdSoyad: serviceRecordData.musteriAdSoyad,
                cihazSeriNumarasi: serviceRecordData.cihazSeriNumarasi
            });
        }
    });
};

/**
 * Mevcut servis kaydını güncelleme
 */
export const updateServiceRecord = async (id, serviceRecordData) => {
    const docRef = doc(db, "serviceRecords", id);
    await updateDoc(docRef, serviceRecordData);
};

/**
 * Form verisini servis kaydı objesine çevir
 */
export const buildServiceRecordData = (formData) => {
    const { customer, device, teslimTarihi, teslimAlmaTarihi, ...rest } = formData;
    return {
        kayitTipi: 'servis',
        musteriId: customer.id,
        musteriAdSoyad: customer.adSoyad,
        musteriTelefon: customer.telefon,
        cihazId: device.id,
        cihazSeriNumarasi: device.seriNumarasi,
        cihazMarkaModel: `${device.marka} ${device.model}`,
        cihazSinifi: device.cihazSinifi || '',
        isSgk: device.isSgk || false,
        zimmetTarihi: device.zimmetTarihi || null,
        arizaTanimi: rest.arizaTanimi,
        yapilanIslemler: rest.yapilanIslemler,
        kullanilanParcalar: rest.kullanilanParcalar,
        toplamTutar: rest.toplamTutar,
        odenenTutar: Number(rest.odenenTutar),
        kalanTutar: rest.toplamTutar - Number(rest.odenenTutar),
        odemeTipi: rest.odemeTipi,
        servisNotlari: rest.servisNotlari,
        teslimTarihi: teslimTarihi ? Timestamp.fromDate(teslimTarihi) : null,
        bakimTuru: rest.bakimTuru,
        oksijenOrani: rest.oksijenOrani,
        basincDegeri: rest.basincDegeri,
        calismaSuresi: rest.calismaSuresi,
        cihazHurdada: rest.cihazHurdada,
        teslimAlmaTarihi: teslimAlmaTarihi ? Timestamp.fromDate(teslimAlmaTarihi) : null,
        teslimAlmadim: rest.teslimAlmadim,
        teslimSaati: rest.teslimSaati || null
    };
};
